import { memo } from "react";
import Image from "next/image";
import { cn } from "@/lib/utils";
import { Typography } from "@/components/Typography";

type StatKey = "hotel" | "rental" | "spa_msg" | "tour_act";

type StatEntry = {
  icon: string;
  total: number;
};

export type DestinationStatsProps = {
  stats: Record<StatKey, StatEntry>;
  className?: string;
};

const STAT_CONFIGS: readonly {
  key: StatKey;
  singular: string;
  plural: string;
}[] = [
  { key: "hotel", singular: "Accommodation", plural: "Accommodations" },
  { key: "rental", singular: "Rental", plural: "Rentals" },
  { key: "spa_msg", singular: "Spa & Massage", plural: "Spas & Massages" },
  { key: "tour_act", singular: "Activity", plural: "Activities" },
];

const DestinationStats = ({ stats, className }: DestinationStatsProps) => {
  return (
    <div className={cn("flex items-center gap-4 justify-start", className)}>
      {STAT_CONFIGS.map(({ key, singular, plural }) => {
        const entry = stats[key];
        if (!entry) return null;

        const label = entry.total > 1 ? plural : singular;

        return (
          <div key={key} className="flex items-center gap-2">
            <Image
              src={entry.icon}
              alt={label}
              width={18}
              height={18}
              className="size-4 shrink-0"
            />
            <Typography variant="subtitle2" className="truncate font-semibold">
              {entry.total}
            </Typography>
          </div>
        );
      })}
    </div>
  );
};

export default memo(DestinationStats);
